// data.js
export default {
  year: new Date().getFullYear(),
  goal: 47.4,
  current: 6.2,
  benchmark: 7.2,
};
